import { formatDate } from '@common/paymentsUtils/dateUtils';
import { Alert, Box, Paragraph, Text } from '@zillow/constellation-10';

import PontoonConstants from '@common/constants/PontoonExceptionConstants';

interface Props {
  dueDate: string;
}

const OverdueSchedulingPage = ({ dueDate }: Props) => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Alert tone="critical">Your rent payment is overdue</Alert>
      <Box>
        <Paragraph textStyle="body-bold">Pay on</Paragraph>
        <Text>
          {formatDate(dueDate, 'MMM d, yyyy', PontoonConstants.RENTER_HUB.PAYMENTS_SETTINGS.RENT_PAYMENT.DUE_DATE)}
        </Text>
      </Box>
      <Alert tone="info">
        Your payment will be processed immediately. If this date falls on a weekend or holiday, we’ll send the rent 1
        business day later.
      </Alert>
    </Box>
  );
};

export default OverdueSchedulingPage;
